"use client";

import { useEffect, useState } from "react";
import { useAuth } from "@clerk/nextjs";
import { Group, Stack, Button, Image, Title, Text } from "@mantine/core";
import Link from "@/components/Link";
import StaticBanner from "@/components/StaticBanner";
import {
  initAnalytics,
  regenerateAnalyticsIdentity,
  setAnalyticsUserId,
} from "@/lib/client/analytics";
import { getCookie, setCookie } from "@/lib/client/cookies";
import { COOKIE_CONSENT_CHANGED_EVENT } from "@/lib/client/referralTracking";
import styles from "./styles.module.scss";

const CookieConsent = () => {
  const { userId } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookie("cookieConsent")) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const close = (value: boolean | string) => {
    setCookie("cookieConsent", value, { path: "/", maxAge: 31536000 * 10 });
    window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGED_EVENT));
    if (value === true) {
      regenerateAnalyticsIdentity();
      setAnalyticsUserId(userId || null);
      initAnalytics(userId);
    }
    setVisible(false);
  };

  return (
    <StaticBanner>
      <Group align="center" gap="lg" p={{ base: "xs", md: "lg" }} className={styles.cookieConsent}>
        <Image
          src="/cookie-banner-140.webp"
          srcSet="/cookie-banner-50.webp 50w, /cookie-banner-140.webp 140w"
          sizes="(max-width: 849px) 50px, 140px"
          alt="Cookie"
          width={140}
          height={140}
          aria-hidden="true"
          className={styles.cookieImage}
        />
        <Stack gap="sm" className={styles.content}>
          <Title order={3} fz={{ base: "sm", md: "md" }}>
            Cookie Consent
          </Title>
          <Text fz={{ base: "xs", md: "sm" }}>
            We use cookies to make our website more enjoyable for you. Read our{" "}
            <Link href="/about?section=terms" className={styles.termsLink}>
              Terms here
            </Link>
            .
          </Text>
          <Group gap="sm" mt="xs">
            <Button variant="ghost" onClick={() => close(true)} size="xs">
              Accept all
            </Button>
            <Button variant="ghost" onClick={() => close("rejected")} size="xs">
              Reject all
            </Button>
          </Group>
        </Stack>
      </Group>
    </StaticBanner>
  );
};

export default CookieConsent;
